// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2937 ? "eabe11fc" : chunkId) + "." + {"550":"249d7fbdfd538d6c","1167":"6124dd0f51fc9f8f","1544":"50168cdf3e818fd8","2937":"0ae2fc961b059dac","7882":"8f287b85cd26f6c9"}[chunkId] + ".js";
};